import { Head, usePage } from "@inertiajs/react"

import AnnouncementForm from "@/components/announcements/announcement-form"
import AppLayout from "@/layouts/app-layout"

export default function New() {
  const page = usePage()
  const search = page.url.includes("?") ? page.url.split("?")[1] : ""
  const params = new URLSearchParams(search)
  const from = params.get("from")

  return (
    <AppLayout title="Nuevo Anuncio">
      <Head title="Crear Anuncio" />
      <div className="mx-auto max-w-6xl p-4 md:p-6">
        <AnnouncementForm
          title="Crear anuncio"
          submitPath="/anuncios"
          method="post"
          onSuccessRedirect={from ?? "/feed"}
        />
      </div>
    </AppLayout>
  )
}
